import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { QueryIndexCompleted } from 'src/core/actions/category/category.actions';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';

@Component({
    selector: 'ca-query-index-completed-notification',
    templateUrl: './query-index-completed-notification.component.html',
    styleUrls: ['./query-index-completed-notification.component.scss'],
    standalone: false
})
@NotificationType('QueryIndexCompletedNotification', QueryIndexCompletedNotificationComponent)
export class QueryIndexCompletedNotificationComponent implements OnInit {
  data: NotificationDto;

  get queryName(): string {
    return this.data ? JSON.parse(this.data.payload).queryName : '';
  }

  constructor() {}

  ngOnInit(): void {}

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    context: any,
    injector: Injector
  ) {
    const parsedPayload = JSON.parse(payload);
    const message = localizationService.instant(
      'Query::IndexingCompletedNotification',
      parsedPayload.queryName
    );

    toastr.success(message);
    const store = injector.get(Store);
    store.dispatch(new QueryIndexCompleted(parsedPayload.queryId));
  }
}
